<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false" >
        <template #title>
          <strong>修改信息</strong>
        </template>
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.replace('/me')"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <header>
      <div :class="{ 'mr-loading': uploadStatus }">
        <label for="avatar" class="avatar-wrapper">
          <img :src="userInfo.domain + form.avatar">
          <span class="iconfont icon-xiangji"></span>
        </label>
        <van-loading v-show="uploadStatus" class="van-loading"></van-loading>
        <input id="avatar" type="file" accept="image/png,image/jpeg,image/jpg" hidden @change="saveAvatar">
      </div>
      <h2 class="fs-18">{{ userInfo.nickname }}</h2>
    </header>
    <section>
      <van-form class="form">
        <div class="form-item">
          <label for="">艺名 / 公司名</label>
          <input type="text" disabled :value="userInfo.nickname">
        </div>
        <div class="form-item">
          <label for="">真实姓名</label>
          <input type="text" disabled :value="userAccountInfo.real_name || '未认证'">
        </div>
        <div class="form-item">
          <label for="">英文名</label>
          <input v-model="form.english_name" placeholder="请输入英文名" type="text">
        </div>
        <div class="form-item">
          <label for="">出生日期</label>
          <div class="flex justify-between select" @click="openSelect('birthday')">
            <span v-if="form.birthday" style="color: #333;">{{ form.birthday }}</span>
            <span v-else>请选择</span>
            <van-icon name="arrow-down" />
          </div>
        </div>
        <div class="form-item">
          <label for="">生活城市</label>
          <input v-model="form.livingcity" placeholder="请输入生活城市" type="text">
        </div>
        <div class="form-item">
          <label for="">Email</label>
          <input v-model="form.email" type="text" placeholder="请输入Email">
        </div>
        <div class="form-item">
          <label for="">音乐人属性</label>
          <div class="flex justify-between select" @click="openSelect('attribute')">
            <span v-if="form.attribute" style="color: #333;">{{ form.attribute }}</span>
            <span v-else>请选择</span>
            <van-icon name="arrow-down" />
          </div>
        </div>
        <div class="form-item">
          <label for="">音乐人身份</label>
          <div class="flex justify-between select" @click="openSelect('capacity')">
            <span v-if="form.capacity" style="color: #333;">{{ form.capacity }}</span>
            <span v-else>请选择</span>
            <van-icon name="arrow-down" />
          </div>
        </div>
        <div class="form-item">
          <label for="">教育程度</label>
          <input v-model="form.education" type="text" placeholder="请输入教育程度">
        </div>
        <div class="form-item">
          <label for="">代表作</label>
          <input v-model="form.represent" type="text" placeholder="请输入代表作">
        </div>
        <div class="form-item">
          <label for="">流派</label>
          <div class="flex justify-between select" @click="openSelect('genre')">
            <span v-if="form.genre" style="color: #333;">{{ form.genre }}</span>
            <span v-else>请选择</span>
            <van-icon name="arrow-down" />
          </div>
        </div>
        <div class="form-item">
          <label for="">百度词条链接</label>
          <input v-model="form.entrylink" type="text" placeholder="请输入百度词条链接">
        </div>
        <div class="form-item">
          <label for="">酷狗音乐人主页链接</label>
          <input v-model="form.kugoulinks" type="text" placeholder="请输入酷狗音乐人主页链接">
        </div>
        <div class="form-item">
          <label for="">酷我音乐人主页链接</label>
          <input v-model="form.kuwolinks" type="text" placeholder="请输入酷我音乐人主页链接">
        </div>
        <div class="form-item">
          <label for="">网易音乐人主页链接</label>
          <input v-model="form.neteaselinks" type="text" placeholder="请输入网易音乐人主页链接">
        </div>
        <div class="form-item">
          <label for="">QQ音乐人主页链接</label>
          <input v-model="form.qqlinks" type="text" placeholder="请输入QQ音乐人主页链接">
        </div>
        <div class="form-item" style="border: 0 none;">
          <label for="" class="mb-10">个人乐队高清照</label>
          <van-uploader v-model="fileList" :after-read="afterRead" :max-count="1"/>
        </div>
        <div class="form-item">
          <label for="">个人简介</label>
          <textarea v-model="form.bio" cols="30" placeholder="请输入个人简介"></textarea>
        </div>
        <van-button color="#FC3159" block class="br-10" @click="updateInfo">保存</van-button>
      </van-form>
    </section>
    <!-- select面板 -->
    <van-action-sheet v-model="show" :cancel-text="curSelectType === 'birthday' ? null : '取消'" close-on-click-action>
      <template v-if="['attribute', 'capacity'].includes(curSelectType)">
        <p v-for="txt in curSelectType === 'attribute' ? attributeOptions : capacityOptions" :key="txt" class="option-item" :class="{ 'active': txt === (curSelectType === 'attribute' ? form.attribute : form.capacity) }" @click="toggle(txt)">{{ txt }}</p>
      </template>
      <template v-else-if="curSelectType === 'genre'">
        <p v-for="txt in songStyleOptions" :key="txt" class="option-item" :class="{ 'active': txt === form.genre }" @click="toggle(txt)">{{ txt }}</p>
      </template>
      <template v-else-if="curSelectType === 'birthday'">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="confirm"
          @cancel="cancel"
        />
      </template>
    </van-action-sheet>
    <!-- select面板 -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { updateInfo, getSelectList, uploadAvator } from '@/api/common.js'
import areaList from '@/api/area.js'
export default {
  name: 'UpdateInfo',
  data() {
    return {
      show: false,
      uploadStatus: false, // 上传状态
      curSelectType: 'attribute', // 当前select面板的归属者
      currentDate: new Date(), // 出生日期
      maxDate: new Date(),
      minDate: new Date(1950, 0, 1),
      songStyleOptions: [],
      fileList: [], // 上传高清图片列表
      form: {
        username: '',
        email: '',
        english_name: '',
        attribute: '', // 音乐人属性
        capacity: '', // 音乐人身份
        entrylink: '', // 百度词条链接
        bio: '',
        avatar: '',
        oss_src: '',
        birthday: '', // 出生日期
        livingcity: null, // 生活城市
        education: '', // 教育程度
        represent: '', // 代表作
        kugoulinks: '', // 酷狗音乐人主页链接
        kuwolinks: '', // 酷我音乐人主页链接
        neteaselinks: '', // 网易音乐人主页链接
        qqlinks: '', // qq音乐人主页链接
        highphoto: '', // 个人乐队高清图片
        genre: '' // 流派
      },
      areaList
    }
  },
  computed: {
    attributeOptions() {
      return ['男', '女', '组合', '虚拟']
    },
    capacityOptions() {
      return ['原创', '翻唱', 'Remix', '配乐', '词曲作者']
    },
    ...mapState(['userInfo', 'userAccountInfo'])
  },
  async created() {
    let songStyleOptions = sessionStorage.getItem('songStyleOptions')
    if (!songStyleOptions) {
      await this.getSelectList()
    } else {
      this.songStyleOptions = JSON.parse(songStyleOptions)
    }
    await this.$store.dispatch('getUserInfo')
    this.initData()
  },
  methods: {
    initData() {
      this.form.avatar = this.userInfo.avatar
      this.form.attribute = this.userInfo.attribute
      this.form.cp_type = this.userInfo.cp_type
      this.form.email = this.userInfo.email
      this.form.english_name = this.userInfo.english_name
      this.form.links = this.userInfo.links
      this.form.bio = this.userInfo.bio
      this.form.capacity = this.userInfo.capacity
      this.form.kugoulinks = this.userInfo.kugoulinks
      this.form.kuwolinks = this.userInfo.kuwolinks
      this.form.neteaselinks = this.userInfo.neteaselinks
      this.form.qqlinks = this.userInfo.qqlinks
      this.form.represent = this.userInfo.represent
      this.form.education = this.userInfo.education
      this.form.birthday = this.userInfo.birthday
      this.form.entrylink = this.userInfo.entrylink
      this.form.genre = this.userInfo.genre
      this.fileList = this.userInfo.highphoto ? [{ url: this.userInfo.domain + this.userInfo.highphoto, status: 'success' }] : []
      this.form.livingcity = this.userInfo.livingcity
    },
    async saveAvatar(file) {
      const data = file.target.files[0]
      this.uploadStatus = true // 开始上传
      const formData = new FormData()
      formData.append('file', data)
      try {
        const res = await uploadAvator(formData)
        if (res.code === 1) {
          this.form.avatar = res.data.url
        }
      } finally {
        this.uploadStatus = false // 结束上传
      }
    },
    async afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...'
      const formData = new FormData()
      formData.append('file', file.file)
      try {
        const res = await uploadAvator(formData)
        if (res.code === 1) {
          this.form.highphoto = res.data.url
          this.fileList = [{
            url: this.userInfo.domain + res.data.url,
            status: 'success'
          }]
        }
      } finally {
        this.uploadStatus = false // 结束上传
      }

    },
    toggle(evt) {
      this.form[this.curSelectType] = evt
      this.show = false
    },
    openSelect(type) {
      this.curSelectType = type
      this.show = true
    },
    async getSelectList() {
      const res = await getSelectList({ name: '音乐流派' })
      this.songStyleOptions = res.data
      sessionStorage.setItem('songStyleOptions', JSON.stringify(this.songStyleOptions))
    },
    async updateInfo() {
      const {
        email, bio, avatar, english_name, attribute, capacity,
        kugoulinks, kuwolinks, neteaselinks, qqlinks, genre, highphoto,
        represent, education, livingcity, birthday, entrylink
      } = this.form
      const params = {
        email, bio, english_name, attribute, capacity,
        kugoulinks, kuwolinks, neteaselinks, qqlinks, avatar,
        represent, education, birthday, entrylink, genre,
        highphoto,
        livingcity: livingcity
      }
      this.$store.commit('TOGGLE_LOADING', true)
      const res = await updateInfo(params)
      if (res.code === 1) {
        this.$toast.success(res.msg)
        await this.$store.dispatch('getUserInfo')
        this.$router.replace('/me')
      }
      this.$store.commit('TOGGLE_LOADING', false)
    },
    confirm(value) {
      this.show = false
      this.form.birthday = this.$options.filters.formatTime(value, '{y}-{m}-{d}')
    },
    cancel() {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
header{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 25px 0;
  .avatar-wrapper{
    position: relative;
    display: block;
    width: 90px;
    height: 90px;
    overflow: hidden;
    img{
      width: 90px;
      height: 90px;
      object-fit: cover;
      border-radius: 50%;
      overflow: hidden;
    }
    .iconfont{
      position: absolute;
      right: 10px;
      bottom: 10px;
      width: 30px;
      height: 30px;
      font-size: 18px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      box-shadow: 0 0 2px 0 #e5e5e5;
      color: #0D0E15;
      font-weight: 700;
    }
  }
}
.form{
  padding: 0 56px 20px;
}
.form-item{
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  &:not(:last-child){
    border-bottom: 1px solid #eee;
  }
  label{
    font-size: 12px;
    color: #B7BDCA;
  }
  .select{
    font-size: 12px;
    height: 24px;
    color: #B7BDCA;
    padding: 4px 0;
    box-sizing: content-box;
    margin-top: 5px;
  }
  input,textarea{
    height: 26px;
    line-height: 26px;
    padding: 2px 0;
    box-sizing: content-box;
    resize: none;
    font-size: 12px;
    &::placeholder{
      color: #B7BDCA;
    }
  }
  input[disabled]{
    color: #666769;
    font-weight: 700;
  }
  textarea{
    height: 100px;
    border: 1px solid #eee;
    margin-top: 10px;
    text-indent: 10px;
  }
}
.option-item{
  padding: 10px 16px;
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid #eee;
  &.active{
    color: #fc3159;
  }
  &:active{
    background-color: rgba(0, 0, 0, .05);
  }
}
</style>
